<script>
	import { mapMutations,mapState } from 'vuex';

	export default{
		props:['tienda'],
		data(){
			return{
				d:'',
				articulo:{
					upc:'',
					win:'',
					descripcion:'',
					indicador:'',
					unidad:''
				},
				steps: [
				{
					target: `[data-v-step="${this.tienda}"]`,
					content: `Recuerda que debes hacer clic en <strong>guardar</strong>, para continuar con la captura de la aportación.`,
					params: {
						placement: 'right'
					}
				}
				],
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Aceptar'
					}
				},
			}
		},
		computed:{
			...mapState(['alertas']),
		},
		mounted(){
			window.$('#add-exclude').on('shown.bs.modal', () => {
				if(this.alertas){
					this.$tours[`addExclude-${this.tienda}`].start();
				}
			});			
		},
		methods:{
			...mapMutations(['saveArts']),
			closeSecondModal(){
				window.$('#add-exclude').modal('hide');
			},
			setArts(evt){
				this.d += evt.data;
				if(evt.data == null){
					this.d = evt.target.innerText;
				}
				
				let art = window.$.trim(this.d);
				if(art == '100186586'){
					this.articulo.upc = '13803259018';
					this.articulo.win = '100186586';
					this.articulo.descripcion = 'CANON TINTA G190MAGE';
					this.articulo.indicador = 'F';
					this.articulo.unidad = 'EA';
				}

				if(art == '188245'){
					this.articulo.upc = '7500435126472';
					this.articulo.win = '188245';
					this.articulo.descripcion = '9KG ACE';
					this.articulo.indicador = 'F';
					this.articulo.unidad = 'EA';
				}

				if(art == '634391'){
					this.articulo.upc = '41003332002';
					this.articulo.win = '634391';
					this.articulo.descripcion = 'VENTILAD 56" INDUSTR';
					this.articulo.indicador = 'F';
					this.articulo.unidad = 'EA';
				}
			},
			guardar(){
				this.saveArts(this.articulo);
				window.$('#add-exclude').modal('hide');
			}
		}
	}
</script>
<template>
	<div>
		<v-tour :name="`addExclude-${tienda}`" :steps="steps" :options="myOptions"/>
		<div id="add-exclude" class="modal fade modal-second" role="dialog">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="header-modal">
						<label>CREAR ACUERDO: PASO 3 (Aportación)</label>
						<div class="modal-header-buttons">
							<button type="button">
								<i class="far fa-window-maximize"></i>	
							</button>
							<button type="button" @click="closeSecondModal()" >
								<i class="fas fa-times"></i>	
							</button>
						</div>
					</div>
					<div class="body-modal">
						<div class="row">
							<div class="col-md-11 table-options">
								<button> Importar Todo </button>
								<div class="border-bottom-div-modal">
									<button> Incluir </button>
									<button> Excluir </button>
								</div>
								<div class="buttons mt-10">
									<button> Export </button>
									<button> Agregar </button>
									<button> Borrar </button>
									<button> Copiar / Pegar </button>
									<button :data-v-step="tienda" @click="guardar()"> Guardar </button>
									<button> Cancelar </button>
								</div>
								<table class="table-proveedor table-not-hover">
									<tr>
										<td><i class="far fa-clone"></i></td>
										<td>UPC</td>
										<td>WIN(Art#)</td>
										<td>Descripción</td>
										<td>Indicador de Peso Variable</td>
										<td>Unidad de Medida</td>
									</tr>
									<tr>
										<td>&nbsp;</td>
										<td>{{articulo.upc}}</td>
										<td @paste="setArts($event)" @input="setArts($event)" contenteditable=""></td>
										<td>{{articulo.descripcion}}</td>
										<td>{{articulo.indicador}}</td>
										<td>{{articulo.unidad}}</td>
									</tr>
								</table>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>